

export const BaseContainer = ({children = null, classNames= "rounded-xl p-5 border border-[#FCFCFB] bg-white" }) =>(
    <div className={classNames}>{children}</div>
)